import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getUserProfile } from '../lib/profileService';
import { AppShellContext } from './AppShellContext';
import AppHeader from './AppHeader';
import './AppLayout.css';

// Mise en page des écrans connectés : menu général en haut, page en dessous.
function AppLayout() {
  const { session, signOut } = useAuth();
  const userId = session?.user?.id;
  const [profile, setProfile] = useState(null);
  const [crumb, setCrumb] = useState(null);
  const leaveGuardRef = useRef(null);

  useEffect(() => {
    if (!userId) return undefined;
    let cancelled = false;
    getUserProfile(userId)
      .then((data) => {
        if (!cancelled) setProfile(data);
      })
      .catch((err) => console.error('Profil indisponible pour le menu', err));
    return () => {
      cancelled = true;
    };
  }, [userId]);

  const setLeaveGuard = useCallback((guard) => {
    leaveGuardRef.current = guard;
  }, []);

  const guardedNavigate = useCallback((proceed) => {
    if (leaveGuardRef.current) leaveGuardRef.current(proceed);
    else proceed();
  }, []);

  const shell = useMemo(() => ({ setCrumb, setLeaveGuard }), [setLeaveGuard]);

  return (
    <AppShellContext.Provider value={shell}>
      <div className="AppLayout">
        <AppHeader
          profile={profile}
          email={session?.user?.email}
          crumb={crumb}
          guardedNavigate={guardedNavigate}
          onSignOut={signOut}
        />
        <main className="AppLayout-main">
          <Outlet />
        </main>
      </div>
    </AppShellContext.Provider>
  );
}

export default AppLayout;
